import React from 'react';
import { EventCardData } from '../types/GameTypes';
import Card from './Card';
import './ActiveEventCard.css';

interface ActiveEventCardProps {
  card: EventCardData | null;
}

const ActiveEventCard: React.FC<ActiveEventCardProps> = ({ card }) => {
  if (!card) {
    return null;
  }

  return (
    <div className="active-event-card-container">
      <Card
        title={card.name}
        description={card.description}
        className="event-card"
        artwork={<p>EVENT</p>}
      />
    </div>
  );
};

export default ActiveEventCard;
